import { lazy } from "react";
import { Routes, Route } from "react-router-dom";

const LoginController = lazy(() => import("controllers/loginController"));

const LoginRoutes = () => {
  return (
    <Routes>
      <Route path="*" element={<LoginController />} />
    </Routes>
  );
};

export default LoginRoutes;
